const Footer = () => (
  <footer className="py-12 px-4 sm:px-6 lg:px-10">
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4
                      border-t pt-8 text-sm text-muted-foreground">
        <p>
          Andreas Fischinger · Microsoft 365 Spezialist · Zürich
        </p>
        <p>
          <a
            href="mailto:andreas@fischinger.ch"
            className="hover:text-accent transition-colors"
          >
            andreas@fischinger.ch
          </a>
          <span className="mx-2">·</span>
          <span suppressHydrationWarning>© {new Date().getFullYear()}</span>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
